/**
 *
 * AddItemCard
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// components
import AddNewIconButton from 'components/AddNewIconButton';

function AddItemCard({ type, title, description, buttonType, disabeled, addAction, className }) {
  const childClassNames = classNames('add-item-card-wrapper', type, className);

  const addItem = () => {
    addAction();
  };

  return (
    title && (
      <div className={childClassNames}>
        <div className="content">
          {title && <h4 className="title">{title}</h4>}
          {description && <p>{description}</p>}
        </div>

        <div className="actions">
          {buttonType == 'icon' && <AddNewIconButton onClick={addItem} />}
          {buttonType == 'button' && <span className={`add-new-button ${disabeled && 'disabeled'}`} onClick={addItem}>
            Sauvegarder
          </span>}
        </div>
      </div>
    )
  );
}

AddItemCard.defaultProps = {
  type: 'card',
  buttonType: 'icon',
  disabeled: false
};

AddItemCard.propTypes = {
  type: PropTypes.oneOf(['card', 'section']),
  buttonType: PropTypes.oneOf(['icon', 'button']),
  currentItem: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  description: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  disabeled: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
  addItem: PropTypes.func,
};

export default memo(AddItemCard);
